import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Add from "@material-ui/icons/Add";
import get from "lodash/get";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { instance } from "../../../../../Actions/AxiosInstance";
import biometric from "../../../../../Assets/Icons/Biometric/biometric-outline-16px.svg";
import desktop from "../../../../../Assets/Icons/Web/web-16px.svg";
import DeleteIcon from "../../../../../Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import EditIcon from "../../../../../Assets/newicons/action/edit/outline/edit-outline-16px.svg";
import msgIcon from "../../../../../Assets/newicons/app/request-center/outline/request-center-outline-16px.svg";
import autoregularize from "../../../../../Assets/newicons/user-interface/auto-regularize/outline/auto-regularize-outline-16px.svg";
import importicon from "../../../../../Assets/newicons/user-interface/import/outline/import-outline-16px.svg";
import mobileicon from "../../../../../Assets/newicons/user-interface/mobile/outline/mobile-outline-16px.svg";
import admin from "../../../../../Assets/newicons/user/admin/outline/admin-outline-16px.svg";
import walletIcon from "../../../../../Assets/Svg/wallet.svg";
import DynamicForm, {
  validateMyForm,
} from "../../../../../Component/DynamicForm";
import initjson from "../../../../../Component/DynamicForm/Data/initjson";
import { textareainputconverter } from "../../../../../Component/DynamicForm/Fields/Textarea";
import KEYS from "../../../../../Component/DynamicForm/KEYS";
// import DeleteIcon from "../../../../../Component/Icons/delete-small";
import CallOutNew from "../../../../../Component/Headers/callOutNew";
import DrawerHeader from "../../../../../Component/Headers/drawerHeader";
import { ErrorMessages } from "../../../../../Constants";
import moment from "moment";

import {
  convertDateForBackend,
  getFormattedDate,
  getFormattedDayMonthTime,
  getFormattedTimeFromDate,
} from "../../../../../Utils";
import {
  getDisplayNameFromArray,
  getDisplayValueFromArray,
  getOptArr,
  sortArrByDate,
} from "../../../../../Utils/arr";
import {
  dayminusone,
  dayplusone,
  isIndateSameOrBeforeOutdate,
  isIndatetimeSameOrBeforeOutdatetime,
  isIntimeSameOrBeforeOuttime,
  istoday,
  mergeDateTime,
  splitDateTime,
  subtractTime,
  totalTime,
} from "../../../../../Utils/dates";
import "./index.style.css";

let UNIQUEKEY = 0;

class SingleRecord extends Component {
  render() {
    const {
      element,
      onDeleteClick,
      editRequest,
      i,
      onSave,
      onCancel,
      selectedShift,
      istodayflag,
      punchtype,
    } = this.props;
    return (
      element && (
        <div key="key">
          <Paper key="e" className="drawer-container cursor-pointer">
            {selectedShift && selectedShift.uniquekey === element.uniquekey ? (
              <div>
                {element.thisshiftdata && (
                  <div className="section-header-outer bg-color-light-red">
                    <div className="section-header-small-normal">
                      You can punch logs within this time range
                    </div>
                    <div className="section-header-small">{`${getFormattedDayMonthTime(
                      element.thisshiftdata.mindatetime,
                    )} to ${getFormattedDayMonthTime(
                      element.thisshiftdata.maxdatetime,
                    )}`}</div>
                  </div>
                )}
                <DynamicForm
                  fields={inputconverter(element)}
                  formKey="editUpdateAttendanceLogs"
                />
                <div className="action-btn-group clear-float">
                  <Button
                    color="primary"
                    variant="contained"
                    className="btn btn-primary-md-blue"
                    onClick={onSave}
                  >
                    {element.isedit ? "Save" : "Add"}
                  </Button>
                  <Button
                    color="primary"
                    variant="contained"
                    className="btn btn-secondary-md-blue margin-left-10"
                    onClick={onCancel}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            ) : (
              <Grid container>
                <Grid item xs={12} md={1} sm={1}>
                  <span>
                    <img
                      src={
                        element.sourceid == 1
                          ? desktop
                          : element.sourceid == 2
                          ? mobileicon
                          : element.sourceid == 3
                          ? biometric
                          : element.sourceid == 4
                          ? desktop
                          : element.sourceid == 5
                          ? importicon
                          : element.sourceid == 6
                          ? EditIcon
                          : element.sourceid == 7
                          ? admin
                          : element.sourceid == 8
                          ? msgIcon
                          : element.sourceid == 9
                          ? autoregularize
                          : walletIcon
                      }
                      alt="category-icon"
                      height="16"
                    />
                  </span>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={10}
                  sm={10}
                  onClick={() => !istodayflag && editRequest(element)}
                >
                  <span style={{ display: "block", fontSize: 14 }}>
                    {element.transactionlocationfrommobile ||
                      element.transactionlocation ||
                      "-"}
                  </span>
                  {(element.sourceid == 1 ||
                    element.sourceid == 5 ||
                    element.sourceid == 6 ||
                    element.sourceid == 7 ||
                    element.sourceid == 8 ||
                    element.sourceid == 9) && (
                    <span className="expense-selected-list-data margin-top-8">
                      {/* {(element.sourceid == 1 || element.sourceid == 5 || element.sourceid == 6 || element.sourceid == 7 || element.sourceid == 8 || element.sourceid == 9) ? element.ipaddress : element.sourceid == 2 ? `${element.latitude} - ${element.longitude}` : element.deviceserialnumber} */}
                      {element.ipaddress != 0 ? element.ipaddress : ""}
                    </span>
                  )}
                  <span className="expense-selected-list-data margin-top-8">
                    {getFormattedDate(element.transactiondatetime)} -{" "}
                    {/* {getFormattedTimeFromDate(element.transactiondatetime)} */}
                    { moment((element.transactiondatetime), "YYYY-MM-DD hh:mm:ss").format("hh:mm:ss a")}
                    <span
                      className=""
                      style={{
                        marginLeft: 8,
                        fontSize: 12,
                        padding: "2px 16px",
                        borderRadius: 20,
                        border:
                          punchtype == "Out Punch"
                            ? "solid 0px #ddd"
                            : "solid 0px #008985",
                        background:
                          punchtype == "Out Punch" ? "#f7f7f8" : "#dcf2f1",
                        color: punchtype == "Out Punch" ? "#888" : "#008985",

                        display: "inline-block",
                      }}
                    >
                      {punchtype}
                    </span>
                  </span>
                </Grid>
                {!istodayflag && (
                  <Grid item xs={12} md={1} sm={1}>
                    <span className="expense-selected-list-data text-align-right t-bold">
                      <div onClick={() => onDeleteClick(i)}>
                        <img
                          src={DeleteIcon}
                          className="floatright cursour-pointer"
                        />
                        {/* <DeleteIcon /> */}
                      </div>
                    </span>
                  </Grid>
                )}
              </Grid>
            )}
          </Paper>
        </div>
      )
    );
  }
}

const POSTCONST = JSON.stringify({
  employeeid: null,
  requesttypeid: 1,
  attendancerequest: [
    {
      shiftdate: null,
      comment: null,
      insert: [],
      delete: null,
      update: [],
    },
  ],
  sendersourceid: 1,
  recipient: null,
});

const SHIFTCONST = JSON.stringify({
  transactionid: null,
  ipaddress: null,
  transactionlocation: null,
  transactiondatetime: null,
  message: null,
});

// "transactiondatetime"
const FIELDKEYS = [
  "transactiondate",
  "transactiontime",
  "transactionlocation",
  "message",
];

function inputconverter(obj) {
  console.log("obj: ", obj);
  const labels = {
    transactiondate: "Date",
    transactiontime: "Log time",
    transactionlocation: "Location",
    message: "Reason for request",
  };

  const errorTexts = {
    transactiontime: ErrorMessages.E1290,
    message: ErrorMessages.E1280,
  };

  const transactiondateerr = ({ fielddata }) => {
    const { max, value } = fielddata;
    const res = !isIndateSameOrBeforeOutdate({ indate: value, outdate: max });
    return res;
  };

  const transactiontimeerr = ({ fielddata }) => {
    try {
      const {
        thisshiftdata: { mindatetime = null, maxdatetime = null },
        transactiondate = null,
        transactiontime = null,
      } = fielddata;
      const preverr = !isIndatetimeSameOrBeforeOutdatetime({
        indatetime: mindatetime,
        outdatetime: `${convertDateForBackend(
          transactiondate,
        )} ${transactiontime}`,
      });
      const afterr = !isIndatetimeSameOrBeforeOutdatetime({
        indatetime: `${convertDateForBackend(
          transactiondate,
        )} ${transactiontime}`,
        outdatetime: maxdatetime,
      });
      return preverr || afterr;
    } catch (err) {
      console.log("err: ", err);
    }
  };

  const { date, time } = splitDateTime({ datetime: obj.transactiondatetime });
  console.log("dayplusone(date): ", dayplusone(date));
  console.log("date, time: ", date, time);

  return FIELDKEYS.map((key) => ({
    ...initjson,
    ...obj,
    id: key,
    required: true,
    value:
      key === "transactionlocation"
        ? getDisplayValueFromArray(obj.transactionlocation, obj.workRequestType)
        : key === "transactiondate"
        ? date
        : key === "transactiontime"
        ? time
        : obj[key],
    transactiondate: date,
    transactiontime: time,
    errorText: errorTexts[key] || "",
    label: labels[key],
    allowToTypeDate: false,
    options: key === "transactionlocation" ? obj.workRequestType : null,
    min: key === "transactiondate" ? date : null,
    max:
      key === "transactiondate"
        ? obj.thisshiftdata
          ? obj.thisshiftdata.isdaynight
            ? dayplusone(date)
            : date
          : null
        : null,
    typeid:
      key == "transactionlocation"
        ? KEYS.Select
        : key === "transactiondate"
        ? KEYS.Date
        : key === "transactiontime"
        ? KEYS.Time
        : KEYS.TextArea,
    customiserr:
      key == "transactiontime"
        ? transactiontimeerr
        : key === "transactiondate"
        ? transactiondateerr
        : null,
  }));

  // originalDate: obj.transactiondatetime,
  // customerr: key === "transactiondatetime" ? transactiondatetimeerr : null,
  // max:
  //   key === "transactiondatetime"
  //     ? obj.isdaynight
  //       ? moment(dayplusone(obj.transactiondatetime)).format("YYYY-MM-DD")
  //       : moment(obj.transactiondatetime).format("YYYY-MM-DD")
  //     : null,
}

function outputconverter(arr, selectedShift) {
  const result = { ...selectedShift };
  arr.forEach((element) => {
    result[element.id] = element.value;
  });
  result.transactiondatetime = mergeDateTime({
    date: result.transactiondate,
    time: result.transactiontime,
  });
  result.transactionlocationfrommobile = null;
  return result;

  // delete result.workRequestType;
  // delete result.thisshiftdata;
  // delete result.transactiondate;
  // delete result.transactiontime;
  // delete result.uniquekey;

  // return {
  //   transactionid: result.transactionid,
  //   ipaddress: result.ipaddress,
  //   transactionlocation: result.transactionlocation,
  //   transactiondatetime: result.transactiondatetime,
  //   message: result.message,
  //   uniquekey: result.uniquekey,
  // };
}

export default class AllLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      allrequests: [],
      selectedShift: null,
      workRequests: [],
      thisshiftdata: null,
      comment: "",
      istodayflag: false,
      datareceived: false,
    };
    this.getLogs = this.getLogs.bind(this);
    this.delete = this.delete.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
  }

  componentDidMount() {
    this.getLogs();
  }

  getShifts = (date) =>
    instance.post("/attendance/empattendancebyshift", {
      shiftdate: date,
      employeeid: this.props.employeeid,
    });

  async getLogs() {
    const {
      selectedshiftdateObj: { shiftdate, shiftid, shifttimingid },
    } = this.props;
    const shiftresult = await this.getShifts(shiftdate);
    const shifts = get(shiftresult, "data.result", "");
    let thisshiftdata =
      shifts && shifts.find((x) => x.shifttimingid == shifttimingid);

    if (!thisshiftdata) {
      // this.props.enqueueSnackbar(ErrorMessages.E1510, {
      //   variant: "error",
      // });
      this.setState({ isShow: true });
      return false;
    }

    const getearlycutofftime = ({ shiftbegintime, earlycutoff }) => {
      const earlycutofftime = subtractTime({
        timearr: [shiftbegintime, earlycutoff || "00:00:00"],
      });
      const mindatetime = !isIntimeSameOrBeforeOuttime({
        intime: earlycutofftime,
        outtime: shiftbegintime,
      })
        ? convertDateForBackend(dayminusone(shiftdate))
        : shiftdate;
      return `${mindatetime} ${earlycutofftime}`;
    };

    const getendcutofftime = ({ shiftendtime, endcutoff, isdaynight }) => {
      const endcutofftime = totalTime({
        timearr: [shiftendtime, endcutoff || "00:00:00"],
      });
      const maxdatetime = isdaynight
        ? convertDateForBackend(dayplusone(shiftdate))
        : shiftdate;
      return `${maxdatetime} ${endcutofftime}`;
    };
    thisshiftdata = {
      ...thisshiftdata,
      shiftdate: convertDateForBackend(thisshiftdata.shiftdate),
      indate: convertDateForBackend(
        thisshiftdata.indate || thisshiftdata.shiftdate,
      ),
      outdate: convertDateForBackend(
        thisshiftdata.outdate ||
          (thisshiftdata.indate ? "" : thisshiftdata.shiftdate),
      ),
    };
    thisshiftdata = {
      ...thisshiftdata,
      mindatetime: getearlycutofftime(thisshiftdata),
      maxdatetime: getendcutofftime(thisshiftdata),
    };

    const result = await instance.post("attendance/allpunchlogbyempid", {
      employeeid: this.props.employeeid,
      shiftdate,
      shiftid: shiftid || null,
      shifttimingid: shifttimingid || null,
    });

    if (get(result, "data.result[0]", "")) {
      const workRequestTypeRes = await instance.post(
        "attendance/getworkrequest",
        {
          employeeid: this.props.employeeid,
          shiftdate,
        },
      );
      const allrequests = get(result, "data.result", []).map((req, i) => ({
        ...req,
        punchtype: req.devicedirectionid == 1 ? "In Punch" : req.devicedirectionid == "2" ? "Out Punch" : ((i + 1) % 2 == 0 ? "Out Punch" : "In Punch"),
        transactionlocationfrommobile: req.transactionlocation,
        transactionlocation: getDisplayValueFromArray(
          req.transactionlocation,
          workRequestTypeRes.data.result,
        ),
        workRequestType: getOptArr({
          arr: get(workRequestTypeRes, "data.result", []),
          displaynamekey: "displayname",
          displayvaluekey: "displayname",
        }),
        thisshiftdata,
        uniquekey: i + 1,
      }));
      UNIQUEKEY = get(result, "data.result", []).length + 2;
      this.setState({
        isShow: true,
        allrequests,
        istodayflag: istoday(shiftdate),
        selectedShift: null,
        workRequestType: getOptArr({
          arr: get(workRequestTypeRes, "data.result", []),
          displaynamekey: "displayname",
          displayvaluekey: "displayname",
        }),
        thisshiftdata,
        datareceived: true,
      });
    } else {
      this.setState({
        isShow: true,
      });
    }
  }

  editRequest = (shift) => {
    const { selectedShift } = this.state;
    if (selectedShift) {
      this.props.enqueueSnackbar(ErrorMessages.E1270, { variant: "error" });
      return;
    }
    this.setState({ selectedShift: null }, () => {
      this.setState({ selectedShift: { ...shift, isedit: true } });
    });
  };

  add = () => {
    const { selectedShift } = this.state;
    if (selectedShift) {
      this.props.enqueueSnackbar(ErrorMessages.E1270, { variant: "error" });
      return;
    }
    this.setState({ selectedShift: null }, () => {
      const data = JSON.parse(SHIFTCONST);
      data.workRequestType = this.state.workRequestType;
      data.thisshiftdata = this.state.thisshiftdata;
      data.transactiondatetime = this.props.selectedshiftdateObj.shiftdate;
      UNIQUEKEY += 1;
      data.uniquekey = UNIQUEKEY;
      this.setState({ selectedShift: data });
    });
  };

  onSave() {
    const { selectedShift, postDataInState, workRequestType } = this.state;
    let { allrequests } = this.state;
    const { employeeid, selectedshiftdateObj, recipient } = this.props;
    const { error, fields = [] } = validateMyForm({
      formKey: "editUpdateAttendanceLogs",
      enqueueSnackbar: this.props.enqueueSnackbar,
    });
    if (!error) {
      const postData = postDataInState || JSON.parse(POSTCONST);
      postData.employeeid = employeeid;
      postData.recipient = recipient;
      postData.attendancerequest[0].shiftdate = convertDateForBackend(
        selectedshiftdateObj.shiftdate,
      );
      const outputData = this.deleteObjKeysFromArray([
        outputconverter(fields, selectedShift),
      ]);
      outputData[0].transactionlocation = getDisplayNameFromArray(
        outputData[0].transactionlocation,
        workRequestType,
        "displayvalue",
      );
      outputData[0].transactionlocation =
        outputData[0].transactionlocation || "Work From Officee";
      console.log("outputDataaft: ", outputData);
      const reqdatatoshow = { ...selectedShift, ...outputData[0] };
      const key = selectedShift.transactionid ? "update" : "insert";
      const postdataindex = get(
        postData,
        `attendancerequest[0][${key}]`,
        [],
      ).findIndex((x) => x.uniquekey == selectedShift.uniquekey);
      postdataindex != -1
        ? (postData.attendancerequest[0][key][postdataindex] = outputData[0])
        : (postData.attendancerequest[0][key] = [
            ...postData.attendancerequest[0][key],
            ...outputData,
          ]);
      const i = allrequests.findIndex(
        (x) => x.uniquekey == selectedShift.uniquekey,
      );
      i != -1
        ? (allrequests[i] = reqdatatoshow)
        : (allrequests = [...allrequests, reqdatatoshow]);
      this.setState({
        postDataInState: postData,
        allrequests,
        selectedShift: null,
      });
    }
  }

  onDeleteClick(index) {
    this.props.enqueueSnackbar("Are you sure you want to delete?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            this.delete(index);
            this.props.closeSnackbar();
          }}
        >
          Delete
        </Button>,
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => this.props.closeSnackbar()}
        >
          Dismiss
        </Button>,
      ],
    });
  }

  deleteObjKeysFromArray = (arr = [], isdelete) => {
    arr = arr.map((x) => {
      delete x.workRequestType;
      delete x.thisshiftdata;
      x.message = isdelete ? "deleted" : x.message || "";
      return x;
    });
    return arr;
  };

  delete(index) {
    const { employeeid, selectedshiftdateObj, recipient } = this.props;
    const { allrequests, postDataInState } = this.state;
    const postData = postDataInState || JSON.parse(POSTCONST);
    postData.employeeid = employeeid;
    postData.recipient = recipient;
    postData.attendancerequest[0].shiftdate = convertDateForBackend(
      selectedshiftdateObj.shiftdate,
    );
    const transactionid = allrequests[index].transactionid;
    const thisuniquekey = allrequests[index].uniquekey;
    if (postDataInState) {
      if (transactionid) {
        postData.attendancerequest[0].delete = postData.attendancerequest[0]
          .delete
          ? `${postData.attendancerequest[0].delete},${transactionid}`
          : transactionid;
        postData.attendancerequest[0].deletedata = this.deleteObjKeysFromArray(
          postData.attendancerequest[0].deletedata
            ? [...postData.attendancerequest[0].deletedata, allrequests[index]]
            : [allrequests[index]],
          true,
        );
      } else {
        postData.attendancerequest[0].insert = get(
          postData,
          "attendancerequest[0].insert",
          [],
        ).filter((x) => x.uniquekey != thisuniquekey);
      }
    } else {
      postData.attendancerequest[0].delete = transactionid;
      postData.attendancerequest[0].deletedata = this.deleteObjKeysFromArray(
        [allrequests[index]],
        true,
      );
    }
    this.setState({
      postDataInState: postData,
      state: "list",
      allrequests: allrequests.filter((x) => x.transactionid != transactionid),
    });
  }

  onCancel = () => {
    this.setState({ selectedShift: null });
    UNIQUEKEY += 1;
  };

  postRequest = () => {
    const { postDataInState, comment } = this.state;
    if (!comment) {
      this.props.enqueueSnackbar(ErrorMessages.E1280, { variant: "error" });
      return;
    }
    if (
      !postDataInState.recipient ||
      (postDataInState.recipient && postDataInState.recipient.length == 0)
    ) {
      this.props.enqueueSnackbar(
        "Something went wrong please try again later",
        { variant: "error" },
      );
      return;
    }
    const postObj = {
      ...postDataInState,
      attendancerequest: get(postDataInState, "attendancerequest", []).map(
        (x) => ({
          ...x,
          comment,
          deletedata:
            get(x, "deletedata", []).length != 0
              ? get(x, "deletedata", []).map((y) => ({
                  transactionid: y.transactionid,
                  ipaddress: y.ipaddress,
                  transactionlocation: y.transactionlocation,
                  transactiondatetime: y.transactiondatetime,
                  message: y.message,
                }))
              : null,
          delete: x.delete ? `${x.delete}` : null,
          insert:
            get(x, "insert", []).length != 0
              ? get(x, "insert", []).map((y) => ({
                  transactionid: null,
                  ipaddress: y.ipaddress,
                  transactionlocation: y.transactionlocation,
                  transactiondatetime: y.transactiondatetime,
                  message: y.message,
                }))
              : null,
          update:
            get(x, "update", []).length != 0
              ? get(x, "update", []).map((y) => ({
                  transactionid: y.transactionid,
                  ipaddress: y.ipaddress,
                  transactionlocation: y.transactionlocation,
                  transactiondatetime: y.transactiondatetime,
                  message: y.message,
                }))
              : null,
        }),
      ),
    };

    instance
      .post("attendance/createattendancelog", postObj)
      .then(() => {
        this.props.enqueueSnackbar(ErrorMessages.E0040, { variant: "success" });
        this.props.closeDrawer();
        // this.getLogs();
      })
      .catch((e) => {
        this.props.enqueueSnackbar(
          e.response ? e.response.data.error.message : e.message,
          {
            variant: "error",
          },
        );
      });
  };

  render() {
    const {
      selectedShift,
      allrequests,
      postDataInState,
      comment = "",
      istodayflag,
      datareceived,
    } = this.state;
    const { selectedshiftdateObj } = this.props;
    return (
      <div className="height100">
        <div className="drawer-bg">
          <DrawerHeader
            header={
              <span>
                <FormattedMessage id="#" defaultMessage="All logs for" />{" "}
                {get(selectedshiftdateObj, "shiftdate", "")}
              </span>
            }
            // isbackarrow={allrequests.length > 0 && status !== "list"}
            closeDrawer={() => this.props.closeDrawer()}
          />

          <div>
            {this.state.isShow == true && (
              <>
                {allrequests && allrequests.length == 0 && !selectedShift ? (
                  <div className="margin-bottom-8 margin-top-8">
                    {/* <div className="section-header-small-normal text-align-center">No logs available</div> */}
                    <CallOutNew
                      classnames="bg-light-blue width100"
                      header="No logs available"
                      emoji=""
                      textcolor="#1e8ced"
                    />
                  </div>
                ) : (
                  <>
                    {datareceived &&
                      sortArrByDate({
                        arr: allrequests,
                        datekey: "transactiondatetime",
                      }).map((element, i) => (
                        <SingleRecord
                          onSave={this.onSave}
                          onCancel={this.onCancel}
                          editRequest={this.editRequest}
                          element={element}
                          onDeleteClick={this.onDeleteClick}
                          i={i}
                          selectedShift={selectedShift}
                          istodayflag={istodayflag}
                          punchtype={element.punchtype}
                        />
                      ))}
                    {selectedShift &&
                    selectedShift !== null &&
                    !selectedShift.isedit ? (
                      <Paper className="clear-float padding-left-28 drawer-container margin-top-20">
                        <div>
                          {selectedShift.thisshiftdata && (
                            <div className="section-header-outer bg-color-light-red">
                              <div className="section-header-small-normal">
                                You can punch logs within this time range
                              </div>
                              <div className="section-header-small">{`${getFormattedDayMonthTime(
                                selectedShift.thisshiftdata.mindatetime,
                              )} to ${getFormattedDayMonthTime(
                                selectedShift.thisshiftdata.maxdatetime,
                              )}`}</div>
                            </div>
                          )}
                          <DynamicForm
                            fields={inputconverter(selectedShift)}
                            formKey="editUpdateAttendanceLogs"
                          />
                          <div className="action-btn-group clear-float">
                            <Button
                              color="primary"
                              variant="contained"
                              className="btn btn-primary-md-blue"
                              onClick={this.onSave}
                            >
                              {selectedShift.isedit ? "Save" : "Add"}
                            </Button>
                            <Button
                              color="primary"
                              variant="contained"
                              className="btn btn-secondary-md-blue margin-left-10"
                              onClick={this.onCancel}
                            >
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Paper>
                    ) : (
                      !istodayflag && (
                        <Paper
                          style={{
                            padding: "30px 16px",
                            textAlign: "center",
                            border: "1px dashed #1e8ced",
                          }}
                        >
                          <div className="cursour-pointer" onClick={this.add}>
                            <Add
                              style={{
                                height: 16,
                                width: 16,
                                marginLeft: 8,
                                marginRight: 16,
                                position: "relative",
                                top: 3,
                                borderRadius: 16,
                                background: "#1e8ced",
                                color: "#fff",
                              }}
                            />
                            <span
                              style={{
                                color: "#1e8ced",
                                fontSize: 14,
                                fontWeight: "bold",
                              }}
                            >
                              Add
                            </span>
                          </div>
                        </Paper>
                      )
                    )}

                    {postDataInState && (
                      <div className="margin-top-8 margin-bottom-8">
                        <DynamicForm
                          fields={textareainputconverter({
                            label: "comment",
                            value: comment,
                            error: !comment,
                          })}
                          onChange={(val) => this.setState({ comment: val })}
                        />
                      </div>
                    )}

                    {postDataInState && (
                      <div className="action-btn-group clear-float">
                        <Button
                          color="primary"
                          variant="contained"
                          className="btn btn-primary-md-green"
                          // disabled={!postDataInState}
                          onClick={this.postRequest}
                        >
                          Send request
                        </Button>
                      </div>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}

/*
const INSERT = {
  employeeid: 321,
  requesttypeid: 1,
  attendancerequest: [
    {
      shiftdate: "2019-08-15",
      comment: null,
      insert: null,
      delete: null,
      update: [
        {
          transactionid: 2294,
          ipaddress: "0",
          transactionlocation: "Work From Office",
          transactiondatetime: "2019-08-15 09:00:00",
          message: "asdasd",
        },
        {
          transactionid: 2295,
          ipaddress: "0",
          transactionlocation: "Work From Office",
          transactiondatetime: "2019-08-15 18:00:00",
          message: "asdasdasdasdasd",
        },
      ],
    },
  ],
  sendersourceid: 1,
  recipient: null,
};

const UPDATE = {
  employeeid: 321,
  requesttypeid: 1,
  attendancerequest: [
    {
      shiftdate: "2019-08-15",
      comment: null,
      insert: [
        {
          transactionid: null,
          ipaddress: "0",
          transactionlocation: "Work From Office",
          transactiondatetime: "2019-08-15 09:00:00",
          message: "asdasd",
        },
      ],
      delete: null,
      update: null,
    },
  ],
  sendersourceid: 1,
  recipient: null,
};

const DELETE = {
  employeeid: 321,
  requesttypeid: 1,
  attendancerequest: [
    {
      shiftdate: "2019-08-15",
      comment: null,
      insert: null,
      delete: "2295",
      update: null,
    },
  ],
  sendersourceid: 1,
  recipient: null,
};
*/
